
import { LeadFunnelDataSource, ListDataSource } from "@/data/List/ListDataSource";
import {Component,Vue} from "vue-property-decorator";
import TunnelEditor from "./comonents/tunnel-editor.vue";
import draggable from "vuedraggable";
@Component({
  components: {
    draggable,
    TunnelEditor
  }
})
export default class KanbanEdit extends Vue {
  $message:any;
  loaded:boolean = false;

  dataSource:LeadFunnelDataSource = new LeadFunnelDataSource({
    className:"LeadFunnel",
    config: {
      orderFieldName:"Priority",
      orderFieldDirection:"ASC",
    }
  })

  async setDefault(item:any, event:any){
    if(!event) return;

    await this.dataSource.setDefault(item.id);    
  }

  async add(){
    await this.dataSource.add({
      caption:"Воронка " + (this.dataSource.items.length + 1)
    })
  }

  async remove(item:any,childCount:number){
    if(childCount > 0) {
      this.$message("С начало удалите этапы")
      return;
    }
    await this.dataSource.remove(item.id)
  }

  async mounted(){
    await this.dataSource.get();
  }
}
